import React, { useState, useEffect } from "react";
import "../../styles/pages/TooltipBox.scss";

const TooltipBox = ({
  setSelectedtab,

  banner,
  setIsOpen,
  isOpen,
}) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);
  //   () => {
  //   return localStorage.getItem('dontShowAgain') === 'true';
  // });

  useEffect(() => {
    // Reset the dontShowAgain state when the selectedTab or banner changes
    const Notifiationmissed = localStorage.getItem("dontShowAgain") === "true";
    if (Notifiationmissed) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
    // setDontShowAgain(localStorage.getItem('dontShowAgain') === 'true');
  }, [banner]);

  useEffect(() => {
    setDontShowAgain(false);
  }, [banner]);

  const handleClose = () => {
    // setDontShowAgain(true);
    //localStorage.setItem('dontShowAgain', 'true');
    setIsOpen(false);
    localStorage.setItem("dontShowAgain", "true");
  };

  const handleCheckboxChange = (event) => {
    const checked = event.target.checked;
    setDontShowAgain(checked);
    //  localStorage.setItem('dontShowAgain', checked ? 'true' : 'false');
  };

  // if (dontShowAgain) {
  //   return null;
  // }

  return (
    <>
      {isOpen && (
        <div className="box-container">
          <div className="card">
            <>
              <p className="styled-paragraph-12">
                {"Create a new banner in 1 simple steps "}
              </p>
              {/* <span className="step-text">Step 1 :</span>
              <p className="styled-paragraph">Import Module(s)</p> */}
              <span className="step-text">Step 1 :</span>
              <p className="styled-paragraph-40">{"Author Banner & Publish"}</p>
              {/* <p className="styled-paragraph-40">{  "Select Template" }</p> */}
              {/* <span className="step-text step3" >Step 3 :</span> */}
              {/* <p className="styled-paragraph-40">{ "Author Banner & Publish" }</p> */}
            </>

            <div className="button-container">
              <label className="checkbox-text d-flex">
                <input
                  type="checkbox"
                  className="styled-checkbox"
                  checked={dontShowAgain}
                  onChange={handleCheckboxChange}
                />
                <span className="checkbox-container23"></span> Don't show me
                again
              </label>
              <span
                className="close-button23"
                onClick={() => {
                  handleClose();
                }}
              >
                OK, GOT IT
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TooltipBox;
